// Vue plugin <eui-switch>:

import { euiGeneriskKryssrutaMixin } from 'v-mixins/euiGeneriskKryssrutaMixin';


const plugin = {

	// Gemensam för alla sådana här komponenter på en sida, vilket är precis det vi vill:
	uniktIdCounter: 0,

	install(Vue, options)
	{
		Vue.component('eui-switch', {

			// All generisk kryssrutefunktionalitet, se 'euiGeneriskKryssrutaMixin.js'.
			// Props:		vpPaslagen, vpInaktiverad, vpOsynlig, vpTooltip, vpAccessKey
			// Data:			uniktId, mixinIsMounted, mixinIsMountedAndNextTick, mixinIsMountedAndSecondNextTick
			// Computed:	skaVaraOsynlig, skaVaraInaktiverad
			// Events:	andrad
			// Model:	vpPaslagen, andrad
			mixins: [ euiGeneriskKryssrutaMixin ],

			// @click.stop.prevent hindrar webbläsarens egna toggling, vilket förhindrar att den får en fokusring vid just klick (den ska få det vid tabbning):
			template: `
				<div class="_eui-switch" :class="{ '-paslagen':vpPaslagen, '-osynlig':skaVaraOsynlig }" :disabled="skaVaraInaktiverad">
					<input :id="uniktId" :checked="vpPaslagen" @change="onChange" :disabled="skaVaraInaktiverad" type="checkbox" :title="vpTooltip">
					<label :for="uniktId" @click.stop.prevent="onChange" :title="vpTooltip">
						<slot></slot>
					</label>
				</div>
			`,

			// Props utöver de från mixin ovan:
			props: {
				//etikett: {			// Får innehålla HTML.
				//	type: String,
				//	default: ''
				//}
			}
		});
	}
};

export { plugin as euiSwitch };
